module.exports = __webpack_public_path__ + "img/yuyin.9f892a06.png";